import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { GoDotFill } from "react-icons/go";
import { useDispatch } from "react-redux";
import { formikValidation, formikinitialvalues } from "../../../../../CommonFunction/common";
import { updateFormData } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import Input from "../../../../Components/Input/Input";
import Button from "../../../Button/Button";
import "./AddJournalVoucherSection.scss";
import JournalVoucherTableRow from "./JournalVoucherTableRow";
import { Addition } from "../../../../../CommonFunction/CalculationsWithDecimalValues";
const { useQuery, gql, useMutation } = require("@apollo/client");

const DeleteTrasaction = gql`
  mutation DeleteTransactions($idsToDelete: [ID!]!) {
    deleteTransaction(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const makeTransactionObj = () => {
  let key = `Account_Name${Math.random() * 10}`;
  return {
    id: Math.random() * 10,
    Transaction_Type: "",
    Account_ID: "",
    Amount: "",
    [`${key}`]: "",
    name: key,
    masterName: "All_Accounts",
  };
};
const AddJournalVoucherSection = ({
  fielddata,
  inputfields,
  Type,
  name,

  classname,

  transactionChange,
  changeDisable,
  title,

  TrasactionData,
  Form_Key,
  TypeOfPortal,
  setFirstLoad = () => { },

}) => {
  
  const [deleteSingleTrasaction, { loading: deleteSingleTrasactionLoading }] = useMutation(DeleteTrasaction);


  const [fields, setfields] = useState(inputfields);
  const [alldata, setalldata] = useState({});
  const [tablerow, settableRow] = useState(
    TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
  );
  const [CrSum, setCrSum] = useState(0);
  const [DrSum, setDrSum] = useState(0);

  useEffect(() => {
    settableRow(
      TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
    );
    transactionChange(
      TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
    );
    transactionChange(
      TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
    );
  }, [TrasactionData]);

  useEffect(() => {
    if (fielddata) {
      let arr = [];

      for (var a = 0; a < fields.length; a++) {
        arr.push({ [fields[a].name]: fielddata[fields[a].name] });
        formik.setFieldValue(fields[a].name, fielddata[fields[a].name]);
      }
      let obj = {};

      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }

      if (obj) {
        setalldata(obj);
      }
    }
  }, [fielddata]);
  useEffect(() => {
    setDrSum(0);
    setCrSum(0);

    if (tablerow.length !== 0) {
      tablerow.forEach((el) => {

        if (el.Transaction_Type === "Credit") {
          if (el.Amount !== "" && el[el.name]) {
            setCrSum((prev) => {

              return Addition(prev, el.Amount);
            });
          }
        }
        if (el.Transaction_Type === "Debit") {
          if (el.Amount !== "" && el[el.name]) {
            setDrSum((prev) => {
              return Addition(prev, el.Amount);
            });
          }

        }
      });
    }
  }, [TrasactionData, tablerow]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (CrSum === DrSum && CrSum !== 0) {
      changeDisable(true);
    } else {
      changeDisable(false);
    }
  }, [DrSum, CrSum]);
  useEffect(() => {
    console.log(alldata, "alldata");
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
    updateFormData(dispatch, Form_Key, Type, alldata);
  }, [alldata]);

  const validate = (values) => {
    console.log(values, "values");
    setalldata({ ...alldata, ...values });
  };

  let formik = useFormik({
    initialValues: formikinitialvalues(inputfields),
    validationSchema: formikValidation(inputfields),

    validate,
    onSubmit: (values) => { },
  });
  console.log(formik.values, "formik.values");
  useEffect(() => {
    setfields(inputfields);
  }, [inputfields]);

  const handleRowClick = (i) => {
    settableRow([...tablerow, { ...makeTransactionObj() }]);
    transactionChange([...tablerow, { ...makeTransactionObj() }]);
  };

  const deleteTransaction = async (id) => {
    await deleteSingleTrasaction({
      variables: { idsToDelete: [id] },
    });
  };

  const handleRowDelete = (id) => {
    if (tablerow.length > 2) {
      let temp = tablerow.filter((e) => {
        return e.id !== id;
      });
      settableRow(temp);
      transactionChange(temp);
      if (typeof id === "string") {
        deleteTransaction(id);
      }
    }
  };


  const onTransactionChange = (e, name, id, Account_ID) => {
    let key = name;
    let value = e.target.value;

    if ((value !== undefined && tablerow && tablerow[0].Amount) || value !== undefined) {
      let updatedData = tablerow.map((el, i) => {
        if (el.id === id) {
          if (name === "Account_ID") {
            return {
              ...el,
              Account_ID: value ? value._id : "",
              Account_Name: value ? value.Account_Name : "",
            };
          }
          return { ...el, [key]: value };
        }
        return el;
      });
      transactionChange(tablerow);
      settableRow(updatedData);
    }

    setFirstLoad(curr => {
      return curr || true;
    });
  };

  useEffect(() => {
    transactionChange(tablerow);
  }, [tablerow]);
  return (
    <>
      {name === "Doc_Details" ? (
        <div className="journalHeader">
          <p>
            Voucher:<span> {title}</span>
          </p>
        </div>
      ) : (
        ""
      )}
      <div>
        <form onSubmit={formik.handleSubmit} autoComplete="off" className="journalHeader2">
          {fields?.map((e) => {
            return (
              <div key={e.id} className={classname ? classname : "sectionDiv" || "sectionone"}>
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig={e}
                  name={e.name}
                  id={e.name}
                  value={alldata[e.name] ? alldata[e.name] : ""}
                  label={e.label}
                  type={e.type}
                  modalform={true}
                  Iconinside={true}
                  handleInputChange={(e) => {
                    console.log(e, "valuevaluevaluevaluevalue");
                    // handleDocData(e);
                    setFirstLoad(true)
                    formik.handleChange(e);
                  }}
                  dropdowndata={e.dropdowncontent}
                  hasApiCallback={e.hasApiCallback}
                  handleBlur={formik.handleBlur}
                  touched={formik.touched[e.name]}
                  error={formik.errors[e.name]}
                  formkey={Form_Key}
                  TypeOfPortal={TypeOfPortal}
                />
              </div>
            );
          })}
        </form>
      </div>
      <div className="tableContainer">
        <table id="Table">
          <tr className="headerRow">
            <td className="PaymentHeader">Cr/Db</td>
            <td className="">Account Name</td>
            <td className="DebitCol">Debit</td>
            <td className="CreditCol">Credit</td>
            <td>Ref</td>
            <td></td>
          </tr>
          {tablerow?.map((el, i) => {
            return (
              <JournalVoucherTableRow
                tablerow={tablerow}
                i={i}
                el={el}
                handleRowDelete={handleRowDelete}
                name={name}
                formik={formik}
                rowData={el.row_id}
                id={el.row_id}
                onTransactionChange={onTransactionChange}
                loadingState={deleteSingleTrasactionLoading ? true : false}
                Form_Key={Form_Key}
                setFirstLoad={setFirstLoad}
                TypeOfPortal={TypeOfPortal}
              />
            );
          })}
          <tfoot className="JournalFooter">
            <tr>
              <td>Total</td>
              <td></td>
              <td className="numberInput">{DrSum}</td>
              <td className="numberInput">{CrSum}</td>
              <td></td>
              <td>
                {DrSum === CrSum && DrSum !== 0 ? (
                  <GoDotFill className={"tallyTick"} />
                ) : DrSum !== 0 || CrSum !== 0 ? (
                  <GoDotFill className={"notTally"} />
                ) : (
                  ""
                )}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <Button action={handleRowClick} text="Add Another Line" name="AddRow" />
    </>
  );
};

export default AddJournalVoucherSection;



// import { useFormik } from "formik";
// import { useEffect, useState } from "react";
// import { GoDotFill } from "react-icons/go";
// import { useDispatch } from "react-redux";
// import { formikValidation, formikinitialvalues } from "../../../../../CommonFunction/common";
// import { updateFormData } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
// import Input from "../../../../Components/Input/Input";
// import Button from "../../../Button/Button";
// import "./AddJournalVoucherSection.scss";
// import JournalVoucherTableRow from "./JournalVoucherTableRow";
// import { Addition } from "../../../../../CommonFunction/CalculationsWithDecimalValues";
// const { useQuery, gql, useMutation } = require("@apollo/client");

// const DeleteTrasaction = gql`
//   mutation DeleteTransactions($idsToDelete: [ID!]!) {
//     deleteTransaction(idsToDelete: $idsToDelete) {
//       message
//     }
//   }
// `;

// export const makeTransactionObj = () => {
//   let key = `Account_Name${Math.random() * 10}`;
//   return {
//     id: Math.random() * 10,
//     Transaction_Type: "",
//     Account_ID: "",
//     Amount: "",
//     [`${key}`]: "",
//     name: key,
//     masterName: "All_Accounts",
//   };
// };
// const AddJournalVoucherSection = ({
//   fielddata,
//   inputfields,
//   Type,
//   name,

//   classname,

//   transactionChange,
//   changeDisable,
//   title,

//   TrasactionData,
//   Form_Key,
//   TypeOfPortal,
//   setFirstLoad = () => { },

// }) => {
//   console.log(TypeOfPortal, "fielddata");
//   const [deleteSingleTrasaction, { loading: deleteSingleTrasactionLoading }] = useMutation(DeleteTrasaction);
//   const [toggle, settoggle] = useState(false);

//   const [fields, setfields] = useState(inputfields);
//   const [alldata, setalldata] = useState({});

//   const [tablerow, settableRow] = useState(
//     TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
//   );

//   const [showEmptyOption, setShowEmptyOption] = useState(true);
//   const [CrSum, setCrSum] = useState(0);
//   const [DrSum, setDrSum] = useState(0);

//   useEffect(() => {
//     settableRow(
//       TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
//     );
//     transactionChange(
//       TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
//     );
//     transactionChange(
//       TrasactionData.length !== 0 ? TrasactionData : [{ ...makeTransactionObj() }, { ...makeTransactionObj() }]
//     );
//   }, [TrasactionData]);

//   useEffect(() => {
//     if (fielddata) {
//       let arr = [];

//       for (var a = 0; a < fields.length; a++) {
//         arr.push({ [fields[a].name]: fielddata[fields[a].name] });
//         formik.setFieldValue(fields[a].name, fielddata[fields[a].name]);
//       }
//       let obj = {};

//       for (var l = 0; l < arr.length; l++) {
//         let temp = arr[l];
//         for (var key in temp) {
//           obj[key] = temp[key];
//         }
//       }

//       if (obj) {
//         setalldata(obj);
//       }
//     }
//   }, [fielddata]);
//   useEffect(() => {
//     setDrSum(0);
//     setCrSum(0);

//     if (tablerow.length !== 0) {
//       tablerow.forEach((el) => {

//         if (el.Transaction_Type === "Credit") {
//           if (el.Amount !== "" && el[el.name]) {
//             setCrSum((prev) => {

//               return Addition(prev, el.Amount);
//             });
//           }
//         }
//         if (el.Transaction_Type === "Debit") {
//           if (el.Amount !== "" && el[el.name]) {
//             setDrSum((prev) => {
//               return Addition(prev, el.Amount);
//             });
//           }

//         }
//       });
//     }
//   }, [TrasactionData, tablerow]);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     if (CrSum === DrSum && CrSum !== 0) {
//       changeDisable(true);
//     } else {
//       changeDisable(false);
//     }
//   }, [DrSum, CrSum]);
//   useEffect(() => {
//     console.log(alldata, "alldata");
//     dispatch({
//       type: "Add_FormFieldData",
//       payload: { data: alldata, key: Type },
//     });
//     updateFormData(dispatch, Form_Key, Type, alldata);
//   }, [alldata]);

//   const validate = (values) => {
//     console.log(values, "values");
//     setalldata({ ...alldata, ...values });
//   };

//   let formik = useFormik({
//     initialValues: formikinitialvalues(inputfields),
//     validationSchema: formikValidation(inputfields),

//     validate,
//     onSubmit: (values) => { },
//   });
//   console.log(formik.values, "formik.values");
//   useEffect(() => {
//     setfields(inputfields);
//   }, [inputfields]);

//   const handleRowClick = (i) => {
//     settableRow([...tablerow, { ...makeTransactionObj() }]);
//     transactionChange([...tablerow, { ...makeTransactionObj() }]);
//   };

//   const deleteTransaction = async (id) => {
//     await deleteSingleTrasaction({
//       variables: { idsToDelete: [id] },
//     });
//   };

//   const handleRowDelete = (id) => {
//     if (tablerow.length > 2) {
//       let temp = tablerow.filter((e) => {
//         return e.id !== id;
//       });
//       settableRow(temp);
//       transactionChange(temp);
//       if (typeof id === "string") {
//         deleteTransaction(id);
//       }
//     }
//   };

//   const handleFocus = () => {
//     setShowEmptyOption(false);
//   };

//   const onTransactionChange = (e, name, id, Account_ID) => {
//     let key = name;
//     let value = e.target.value;

//     if ((value !== undefined && tablerow && tablerow[0].Amount) || value !== undefined) {
//       let updatedData = tablerow.map((el, i) => {
//         if (el.id === id) {
//           if (name === "Account_ID") {
//             return {
//               ...el,
//               Account_ID: value ? value._id : "",
//               Account_Name: value ? value.Account_Name : "",
//             };
//           }
//           return { ...el, [key]: value };
//         }
//         return el;
//       });
//       transactionChange(tablerow);
//       settableRow(updatedData);
//     }

//     setFirstLoad(curr => {
//       return curr || true;
//     });
//   };

//   useEffect(() => {
//     transactionChange(tablerow);
//   }, [tablerow]);
//   return (
//     <>
//       {/* {name === "Doc_Details" ? (
//         <div className="journalHeader">
//           <p>
//             Voucher:<span> {title}</span>
//           </p>
//         </div>
//       ) : (
//         ""
//       )} */}
//       {/* <div>
//         <form onSubmit={formik.handleSubmit} autoComplete="off" className="journalHeader2">
//           {fields?.map((e) => {
//             return (
//               <div key={e.id} className={classname ? classname : "sectionDiv" || "sectionone"}>
//                 <Input
//                   EMTQuery=""
//                   checked={""}
//                   InputConfig={e}
//                   name={e.name}
//                   id={e.name}
//                   value={alldata[e.name] ? alldata[e.name] : ""}
//                   label={e.label}
//                   type={e.type}
//                   modalform={true}
//                   Iconinside={true}
//                   handleInputChange={(e) => {
//                     console.log(e, "valuevaluevaluevaluevalue");
//                     // handleDocData(e);
//                     setFirstLoad(true)
//                     formik.handleChange(e);
//                   }}
//                   dropdowndata={e.dropdowncontent}
//                   hasApiCallback={e.hasApiCallback}
//                   handleBlur={formik.handleBlur}
//                   touched={formik.touched[e.name]}
//                   error={formik.errors[e.name]}
//                   formkey={Form_Key}
//                   TypeOfPortal={TypeOfPortal}
//                 />
//               </div>
//             );
//           })}
//         </form>
//       </div> */}
//       <div className="tableContainer">
//         <table id="Table">
//           <tr className="headerRow">
//             <td className="PaymentHeader">Cr/Db</td>
//             <td className="">Account Name</td>
//             <td className="DebitCol">Debit</td>
//             <td className="CreditCol">Credit</td>
//             <td>Ref</td>
//             <td></td>
//           </tr>
//           {tablerow?.map((el, i) => {
//             return (
//               <JournalVoucherTableRow
//                 tablerow={tablerow}
//                 i={i}
//                 el={el}
//                 handleRowDelete={handleRowDelete}
//                 name={name}
//                 formik={formik}
//                 rowData={el.row_id}
//                 id={el.row_id}
//                 onTransactionChange={onTransactionChange}
//                 loadingState={deleteSingleTrasactionLoading ? true : false}
//                 Form_Key={Form_Key}
//                 setFirstLoad={setFirstLoad}
//               />
//             );
//           })}
//           <tfoot className="JournalFooter">
//             <tr>
//               <td>Total</td>
//               <td></td>
//               <td className="numberInput">{DrSum}</td>
//               <td className="numberInput">{CrSum}</td>
//               <td></td>
//               <td>
//                 {DrSum === CrSum && DrSum !== 0 ? (
//                   <GoDotFill className={"tallyTick"} />
//                 ) : DrSum !== 0 || CrSum !== 0 ? (
//                   <GoDotFill className={"notTally"} />
//                 ) : (
//                   ""
//                 )}
//               </td>
//             </tr>
//           </tfoot>
//         </table>
//       </div>
//       <Button action={handleRowClick} text="Add Another Line" name="AddRow" />
//     </>
//   );
// };

// export default AddJournalVoucherSection;
